import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { cafeInfo } from "@/data/menu";

// TikTok icon component (lucide doesn't include a TikTok glyph in this version)
function TikTokIcon({ size = 18, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden bg-brand text-white"
    >
      <div className="mx-auto max-w-7xl px-6 pt-20 pb-10 md:px-10 md:pt-28">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <p
              className="eyebrow"
              style={{ color: "#a8a39c" }}
            >
              {cafeInfo.address.city} · {cafeInfo.address.zip}
            </p>
            <h2 className="font-display mt-4 text-6xl font-bold leading-[0.9] tracking-tighter md:text-8xl lg:text-9xl">
              Made
              <br />
              <span className="text-matcha italic font-medium">to crave.</span>
            </h2>

            <div className="mt-10 flex flex-wrap items-center gap-3">
              <a
                href={cafeInfo.socials.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-sm transition-all hover:bg-white hover:text-brand"
              >
                <Instagram size={16} />
                Instagram
              </a>
              <a
                href={cafeInfo.socials.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-tiktok"
                aria-label="TikTok"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-sm transition-all hover:bg-white hover:text-brand"
              >
                <TikTokIcon size={16} />
                TikTok
              </a>
            </div>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <p className="eyebrow" style={{ color: "#a8a39c" }}>
                Besuch
              </p>
              <p className="font-display mt-3 text-lg font-medium">
                {cafeInfo.address.street}
                <br />
                {cafeInfo.address.zip} {cafeInfo.address.city}
              </p>
              <a
                href={cafeInfo.phoneHref}
                data-testid="footer-phone"
                className="mt-4 inline-block text-sm text-white/80 link-underline"
              >
                {cafeInfo.phone}
              </a>
              <a
                href={`mailto:${cafeInfo.email}`}
                data-testid="footer-email"
                className="mt-2 block text-sm text-white/80 link-underline break-all"
              >
                {cafeInfo.email}
              </a>
            </div>
            <div>
              <p className="eyebrow" style={{ color: "#a8a39c" }}>
                Öffnungszeiten
              </p>
              <ul className="mt-3 space-y-1.5 text-sm text-white/85">
                {cafeInfo.hours.map((h) => (
                  <li key={h.day} className="flex flex-col">
                    <span className="font-medium text-white">{h.day}</span>
                    <span className="tabular-nums text-white/70">{h.time}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="text-xs text-white/60">
            © {year} {cafeInfo.name}. Alle Rechte vorbehalten.
          </p>
          <nav className="flex flex-wrap gap-6 text-xs text-white/70">
            <Link
              to="/impressum"
              data-testid="footer-impressum-link"
              className="link-underline"
            >
              Impressum
            </Link>
            <a
              href="#menu"
              className="link-underline"
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector("#menu")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Menü
            </a>
            <a
              href="#standort"
              className="link-underline"
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector("#standort")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Standort
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
